import { httpHandler, apiUrls, baseEndpoint } from "../../../services";
import axios from "axios";
import qs from "qs";
import i18n from "../../../i18n";

export default class CreateAppointmentService {
  http = "";
  dynamicFieldsHttp = "";
  constructor() {
    /**
     * TODO: For the time being , we are using static token for API
     */
    // this.httptest =   httpHandler(
    //   baseEndpoint.consumerServiceBaseEndPoint,
    //   "SB5wyf0xMLrWZZPDkw0C21qkhqkM2Dhz9yZhjwwPLqneJQayjZ8xN6senzlm"
    // );

    this.http = httpHandler(baseEndpoint.partnersServiceBaseEndPoint)
    
    // Dynamic fields should use different endpoint based on environment
    // dev.zoofy.nl for development, zoofy.nl for production
    const dynamicFieldsBaseUrl = process.env.NODE_ENV === 'production' 
      ? 'https://zoofy.nl' 
      : 'https://dev.zoofy.nl';
    
    // Create custom HTTP handler for dynamic fields with Accept-Language header
    this.dynamicFieldsHttp = this.createDynamicFieldsHttpHandler(dynamicFieldsBaseUrl);
  }

  /**
   * Create custom HTTP handler for dynamic fields with Accept-Language header
   * @param {string} baseUrl
   */
  createDynamicFieldsHttpHandler(baseUrl) {
    let instance = axios.create({
      baseURL: baseUrl,
      timeout: 360000,
    });

    // Minimal headers - only what's needed
    instance.interceptors.request.use(
      (config) => {
        config.headers["accept"] = "application/json";
        config.headers["accept-language"] = i18n.language;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    return instance;
  }

  /**
   * Reset password(Add new password)
   * @param {object} params
   **/
  fetchTask(params) {
    return this.http.get(apiUrls.createAppointment.tasks);
  }

  fetchTaskDetails(data) {
    return this.http.get(apiUrls.createAppointment.taskDetails(data));
  }
  fetchTaskDynamicFields(data) {
    return this.dynamicFieldsHttp.get(apiUrls.createAppointment.taskDynamicFields(data));
  }

  fetchPartners(params) {
    return this.http.get(apiUrls.createAppointment.partner, params);
  }

  verifyAddress(params) {
    return this.http.post(apiUrls.verify.verifyAddress, params);
  }

  createAppointmentAction(params) {
    return this.http.post(apiUrls.createAppointment.create, JSON.parse(params));
  }

  createAppointmentSubuserAction(params) {
    return this.http.post(apiUrls.createAppointment.subuserCreate, JSON.parse(params));
  }

  findTaskRate(data) {
    return this.http.get(apiUrls.createAppointment.taskRates(data));
  }

  verifyCouponCode(payload) {
    return this.http.get(apiUrls.createAppointment.verifyCoupon(payload.code));
  }
}

export const createAppointment = new CreateAppointmentService();
